import {useSelector } from "react-redux"
import { BALANCE_ADD_ICON, SETTINGS_LOGOUT_ICON } from "../../utils/constants";
import PillSwitch from "../../components/common/PillSwitch";

export const RightNavBalance = () => {
    const selectedDomain = useSelector((state) => state.domain.selectedDomain)
    const reduxState = useSelector(state => state.user)
    
    
    return(
        <div className='nav-box-balance-container'>
        <div className={`nav-box-balance ${selectedDomain}_font`}>{`$${reduxState?.balance?.toFixed(2)}`}</div>
            <div className='nav-box-balance-addIcon'>
                <button className='settings-button-image' >
                    <img src={BALANCE_ADD_ICON} width={"17px"} alt="balanceAddIcon" className="relative top-1" />
                </button>
            </div>
        </div>    
    )
}

export const LeftComponentLabel = ({label}) => {
    const selectedDomain = useSelector((state) => state.domain.selectedDomain)
    return (
        <div className={`nav-box-label ${selectedDomain}_semi_bold_font`}>{label}</div>
    )
}

export const switchWithLabel = (label, switchChecked, setSwitchChecked) => {
    return (
        <div className='nav-box-switch-container'>
            <div className='nav-box-switch-label'>{label}</div>
            <div className='nav-box-switch'>
              <PillSwitch checked={switchChecked} onChange={() => setSwitchChecked(!switchChecked)} size='small'/>
            </div>
        </div>
    )
}

export const LogoutLeftNav = () => {
	const selectedDomain = useSelector((state) => state.domain.selectedDomain)

    return (
        <div className='nav-box-logout-container'>
          <button className='settings-button-image'>
            <img src={SETTINGS_LOGOUT_ICON} width={"20px"}/>
          </button>
          <div className={`nav-box-label-error custom-cursor-pointer ${selectedDomain}_bold_font `}>Logout</div>
        </div>
    )
}

export const navBoxLHSArray = [
    {
        label:"Version",
    },
    {
        label:"Security settings",
    },
    {
        label:"Timezone settings",
    },
]

